// @flow
import React, { useState, useEffect } from 'react';
import { Input, Button, Icon, Label } from 'semantic-ui-react';
import { useSelector, useDispatch } from 'react-redux';
import { productSearch } from '../actions/pages/products.js';
import { Link, useParams, useNavigate } from 'react-router';

type Props = {
  totalProducts: number,
  page: number,
  reportTypeId?: number,
};

const ProductSearch = (props: Props): React$Node => {
  const { totalProducts, page, reportTypeId } = props;

  const dispatch = useDispatch();
  const { url } = useParams();
  const navigate = useNavigate();

  const products = useSelector((state) => state.productList.products);
  const isLoading = useSelector((state) => state.productList.isFetching);
  const searchedCategory = useSelector(
    (state) => state.productList.searchedCategory,
  );
  const searchedKeyword = useSelector(
    (state) => state.productList.searchedKeyword,
  );
  const treeflat = useSelector((state) => state.treenav.treeflat);

  const [searchKeyword, setSearchKeyword] = useState(
    searchedKeyword ? searchedKeyword : '',
  );
  const [reportType, setReportType] = useState(reportTypeId);

  useEffect(() => {
    setSearchKeyword(searchedKeyword ? searchedKeyword : '');
  }, [searchedKeyword]);

  useEffect(() => {
    setReportType(reportTypeId);
  }, [reportTypeId]);

  const renderCategories = () => {
    const displayCategories = [];

    if (treeflat) {
      const chosenCategory = treeflat.entities.categories[searchedCategory];

      const findParent = (categoryItem, categoryList) => {
        categoryList.push(categoryItem);
        if (categoryItem.parentId > 0) {
          const foundCategory =
            treeflat.entities.categories[categoryItem.parentId];
          return findParent(foundCategory, categoryList);
        } else {
          return categoryList;
        }
      };

      if (chosenCategory) {
        if (chosenCategory.parentId > 0) {
          findParent(chosenCategory, displayCategories);
        } else {
          displayCategories.push(chosenCategory);
        }
      }
    }

    return displayCategories;
  };

  // Standard search: Search with set keyword in the current category
  const searchKeyDown = (event) => {
    if (event.key === 'Enter') {
      searchProducts();
    }
  };

  // Standard search: Search with set keyword in the current category
  const searchButtonClicked = (event, { value }) => {
    searchProducts();
  };

  // Search with the current category, but reset the keyword
  const clearKeyword = (event) => {
    setSearchKeyword('');
    dispatch(productSearch(searchedCategory, '', reportTypeId, 1));
  };

  // Reset the searched category, but still search with the keyword.
  const clearCategory = (event) => {
    dispatch(productSearch(null, searchKeyword, reportTypeId, 1));
  };

  const searchProducts = () => {
    dispatch(productSearch(searchedCategory, searchKeyword, reportType));
    navigate(`?keyword=${searchKeyword}`);
  };

  const searchInputChanged = (event, { value }) => {
    value !== undefined && setSearchKeyword(value);
  };

  const filters = renderCategories();

  const FilterLabel = (props: { category: { title: string } }) => (
    <Label className="product-search__filter-tag">
      {props.category.title}
      <Link
        to={
          searchedKeyword ? `/products?keyword=${searchedKeyword}` : '/products'
        }
        onClick={clearCategory}
      >
        <Icon name="delete" />
      </Link>
    </Label>
  );

  return (
    <div className="product-search">
      <div className="product-search__search-box">
        <Input
          loading={isLoading}
          onChange={searchInputChanged}
          onKeyPress={searchKeyDown}
          value={searchKeyword}
          placeholder="Search..."
          className="product-search__search-input"
        />
        <Button
          className="product-search__search-button am_product_search"
          onClick={searchButtonClicked}
        >
          Search
        </Button>
      </div>
      <div className="product-search__search-filter-wrapper">
        <span className="product-search__result-count">
          <strong>
            {products && products.length
              ? (page - 1) * 12 +
                1 +
                ' - ' +
                ((page - 1) * 12 + products.length)
              : '0'}
          </strong>{' '}
          of
          <strong>
            {' '}
            {totalProducts && products && products.length ? totalProducts : '0'}
          </strong>{' '}
          results
        </span>
        <div className="product-search__filter-tag-wrapper">
          {filters && filters.length > 0 && (
            <FilterLabel
              category={filters.reverse().pop()}
              searchedKeyword={searchedKeyword}
            />
          )}

          {searchedKeyword && searchedKeyword.length && (
            <Label className="product-search__filter-tag">
              Keyword: {searchedKeyword}
              <Link to={url} onClick={clearKeyword}>
                <Icon name="delete" />
              </Link>
            </Label>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductSearch;
